export const validateReturnUrl = (rawReturnUrl, allowedScheme, fallbackUrl) => {
  const candidate = String(rawReturnUrl || '').trim();
  if (!candidate) return fallbackUrl;

  try {
    const parsed = new URL(candidate);
    if (parsed.protocol === `${allowedScheme}:`) return parsed.toString();

    const fallback = new URL(fallbackUrl);
    if (
      parsed.protocol === 'https:' &&
      parsed.origin === fallback.origin &&
      (parsed.pathname === '/app' || parsed.pathname.startsWith('/app/'))
    ) {
      return parsed.toString();
    }
  } catch {
    return fallbackUrl;
  }

  return fallbackUrl;
};

export const getSafeReturnUrl = (rawReturnUrl) => validateReturnUrl(
  rawReturnUrl,
  import.meta.env.VITE_ALLOWED_APP_SCHEME,
  import.meta.env.VITE_MIGGUS_APP_URL,
);
